export enum QuestionUIMessages {
  LOAD_QUESTION_ERROR = 'An error occurred while loading the list of Issue.',
  EDIT_QUESTION_SUCCESS = 'Question successfully updated.',
  EDIT_QUESTION_ERROR = 'An error occurred while updating the question.',
  DELETE_QUESTION_CONFIRMATION = 'Are you sure you want to delete question?',
  DELETE_QUESTION_TITLE = 'Delete Question',
  DELETE_QUESTION_SUCCESS = 'Question successfully deleted.',
  DELETE_QUESTION_ERROR = 'An error occurred while updating the question.',
  UPDATE_QUESTION_SUCCESS = 'Question successfully updated.',
  UPDATE_QUESTION_ERROR = 'An error occurred while updating the question.'
}
